import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3a7e360b = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _fcd59b9c = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _3efd4c05 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/index.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/index" */))
const _4b45921a = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _2cfea64c = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _1547e160 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/aalst.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/aalst" */))
const _248e16e2 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/antwerpen.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/antwerpen" */))
const _979d6bba = () => interopDefault(import('../../../pages/informatie-over-verhuizers/bpost-verhuisservice.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/bpost-verhuisservice" */))
const _79603f9d = () => interopDefault(import('../../../pages/informatie-over-verhuizers/brugge.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/brugge" */))
const _0f49921f = () => interopDefault(import('../../../pages/informatie-over-verhuizers/brussel.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/brussel" */))
const _bf010996 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/emigreren.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/emigreren" */))
const _9b78da7e = () => interopDefault(import('../../../pages/informatie-over-verhuizers/gent.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/gent" */))
const _5307cc67 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/hasselt.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/hasselt" */))
const _8202281a = () => interopDefault(import('../../../pages/informatie-over-verhuizers/internationale-verhuizingen.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/internationale-verhuizingen" */))
const _f92b0d0a = () => interopDefault(import('../../../pages/informatie-over-verhuizers/kortrijk.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/kortrijk" */))
const _4df8c048 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/oostende.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/oostende" */))
const _4ff52bd7 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/particuliere-verhuizingen.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/particuliere-verhuizingen" */))
const _3233cdb7 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/verhuisbedrijf.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/verhuisbedrijf" */))
const _27b186fb = () => interopDefault(import('../../../pages/informatie-over-verhuizers/verhuisdozen.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/verhuisdozen" */))
const _76b32390 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/verhuisservice.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/verhuisservice" */))
const _739e8245 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/verhuistips.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/verhuistips" */))
const _458eeed4 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/verhuizen-checklist.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/verhuizen-checklist" */))
const _b40d1564 = () => interopDefault(import('../../../pages/informatie-over-verhuizers/zakelijke-verhuizingen.vue' /* webpackChunkName: "pages/informatie-over-verhuizers/zakelijke-verhuizingen" */))
const _b6243d3c = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _5f874357 = () => interopDefault(import('../../../pages/offertes-aanvragen/uw-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/uw-gegevens" */))
const _2b25682b = () => interopDefault(import('../../../pages/offertes-aanvragen/verhuis-details.vue' /* webpackChunkName: "pages/offertes-aanvragen/verhuis-details" */))
const _055cb59b = () => interopDefault(import('../../../pages/offertes-aanvragen/verhuizen-naar.vue' /* webpackChunkName: "pages/offertes-aanvragen/verhuizen-naar" */))
const _2bf00708 = () => interopDefault(import('../../../pages/offertes-aanvragen/verhuizen-van.vue' /* webpackChunkName: "pages/offertes-aanvragen/verhuizen-van" */))
const _9e8acc6e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _17f1aeb2 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.be-nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _3a7e360b,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _fcd59b9c,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-verhuizers",
    component: _3efd4c05,
    name: "informatie-over-verhuizers"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _4b45921a,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _2cfea64c,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/informatie-over-verhuizers/aalst",
    component: _1547e160,
    name: "informatie-over-verhuizers-aalst"
  }, {
    path: "/informatie-over-verhuizers/antwerpen",
    component: _248e16e2,
    name: "informatie-over-verhuizers-antwerpen"
  }, {
    path: "/informatie-over-verhuizers/bpost-verhuisservice",
    component: _979d6bba,
    name: "informatie-over-verhuizers-bpost-verhuisservice"
  }, {
    path: "/informatie-over-verhuizers/brugge",
    component: _79603f9d,
    name: "informatie-over-verhuizers-brugge"
  }, {
    path: "/informatie-over-verhuizers/brussel",
    component: _0f49921f,
    name: "informatie-over-verhuizers-brussel"
  }, {
    path: "/informatie-over-verhuizers/emigreren",
    component: _bf010996,
    name: "informatie-over-verhuizers-emigreren"
  }, {
    path: "/informatie-over-verhuizers/gent",
    component: _9b78da7e,
    name: "informatie-over-verhuizers-gent"
  }, {
    path: "/informatie-over-verhuizers/hasselt",
    component: _5307cc67,
    name: "informatie-over-verhuizers-hasselt"
  }, {
    path: "/informatie-over-verhuizers/internationale-verhuizingen",
    component: _8202281a,
    name: "informatie-over-verhuizers-internationale-verhuizingen"
  }, {
    path: "/informatie-over-verhuizers/kortrijk",
    component: _f92b0d0a,
    name: "informatie-over-verhuizers-kortrijk"
  }, {
    path: "/informatie-over-verhuizers/oostende",
    component: _4df8c048,
    name: "informatie-over-verhuizers-oostende"
  }, {
    path: "/informatie-over-verhuizers/particuliere-verhuizingen",
    component: _4ff52bd7,
    name: "informatie-over-verhuizers-particuliere-verhuizingen"
  }, {
    path: "/informatie-over-verhuizers/verhuisbedrijf",
    component: _3233cdb7,
    name: "informatie-over-verhuizers-verhuisbedrijf"
  }, {
    path: "/informatie-over-verhuizers/verhuisdozen",
    component: _27b186fb,
    name: "informatie-over-verhuizers-verhuisdozen"
  }, {
    path: "/informatie-over-verhuizers/verhuisservice",
    component: _76b32390,
    name: "informatie-over-verhuizers-verhuisservice"
  }, {
    path: "/informatie-over-verhuizers/verhuistips",
    component: _739e8245,
    name: "informatie-over-verhuizers-verhuistips"
  }, {
    path: "/informatie-over-verhuizers/verhuizen-checklist",
    component: _458eeed4,
    name: "informatie-over-verhuizers-verhuizen-checklist"
  }, {
    path: "/informatie-over-verhuizers/zakelijke-verhuizingen",
    component: _b40d1564,
    name: "informatie-over-verhuizers-zakelijke-verhuizingen"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _b6243d3c,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/uw-gegevens",
    component: _5f874357,
    name: "offertes-aanvragen-uw-gegevens"
  }, {
    path: "/offertes-aanvragen/verhuis-details",
    component: _2b25682b,
    name: "offertes-aanvragen-verhuis-details"
  }, {
    path: "/offertes-aanvragen/verhuizen-naar",
    component: _055cb59b,
    name: "offertes-aanvragen-verhuizen-naar"
  }, {
    path: "/offertes-aanvragen/verhuizen-van",
    component: _2bf00708,
    name: "offertes-aanvragen-verhuizen-van"
  }, {
    path: "/",
    component: _9e8acc6e,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _17f1aeb2,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
